import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  display: block;\n  margin-top: ', 'px;\n\n  &:first-child {\n    margin-top: 0;\n  }\n'], ['\n  box-sizing: border-box;\n  display: block;\n  margin-top: ', 'px;\n\n  &:first-child {\n    margin-top: 0;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  align-items: baseline;\n  color: ', ';\n  display: flex;\n  flex: 1 1 auto;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 1;\n  margin: 0;\n  padding: ', 'px ', 'px;\n'], ['\n  align-items: baseline;\n  color: ', ';\n  display: flex;\n  flex: 1 1 auto;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 1;\n  margin: 0;\n  padding: ', 'px ', 'px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  flex: 0 0 auto;\n'], ['\n  flex: 0 0 auto;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  flex: 1 1 auto;\n  font-size: 12px;\n  text-transform: uppercase;\n'], ['\n  flex: 1 1 auto;\n  font-size: 12px;\n  text-transform: uppercase;\n']);

import styled from 'styled-components';
import { colors, gridSize, math, themed } from '@atlaskit/theme';

export default styled.div(_templateObject, gridSize);

export var Heading = styled.div(_templateObject2, themed({
  light: colors.N300,
  dark: colors.DN300
}), gridSize, math.multiply(gridSize, 1.5));
export var HeadingAfter = styled.div(_templateObject3);
export var HeadingText = styled.div(_templateObject4);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/droplist/dist/esm/styled/Group.js
// module id = 426
// module chunks = 0